export function focusProductPicture (route) {
    if (!route || route.query.focus !== 'picture') {
        return;
    }

    window.setTimeout(() => {
        const node = document.getElementById('product-picture');
        if (!node) {
            return;
        }
        node.scrollIntoView({ block: 'center' });
        node.style.outline = '2px solid #321fdb';
        node.style.borderRadius = '4px';
        const input = node.querySelector('input[type="file"]');
        if (input) {
            input.focus();
        }
    }, 300);
}
